import { render, staticRenderFns } from "./Editorial.vue?vue&type=template&id=78a0bd5c&"
import script from "./Editorial.vue?vue&type=script&lang=js&"
export * from "./Editorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports